import { DicionarioOrtografico } from './../_models/dicionarioOrtografico';
import { AuthenticationService } from './authentication.service';
import { AsyncSubject, ReplaySubject, Subject, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { User } from '../_models';

@Injectable({ providedIn: 'root' })
export class DicionarioOrtograficoService {
  dicionarioOrtograficoEndpoint = `${environment.baseUrl}/dicionarioOrtografico`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthenticationService) {
      
    }
  get() {
    return this.http.get(`${this.dicionarioOrtograficoEndpoint}/get`) || '';
  }
  set(item: DicionarioOrtografico) {
    return this.http.post(`${this.dicionarioOrtograficoEndpoint}/set`, item);
  }
  getById(id: string) {
    return this.http.get(`${this.dicionarioOrtograficoEndpoint}/get/${id}`) || '';
  }
  delete(id: number) {
    return this.http.delete(`${this.dicionarioOrtograficoEndpoint}/delete/${id}`);
  }
  spell(content: string) {
    return this.http.post(`${this.dicionarioOrtograficoEndpoint}/spell`, {text: content} );
  }
}
